export interface ConfigCampanha {
  campanhaId: string;
  campanhaNome: string;
  empresaId: string;
  empresaNome: string;
  herdaPlataforma: boolean;
  taxas: {
    taxa_processamento_pix: number;
    taxa_compra_pontos: number;
    taxa_transferencia_interna: number;
  };
  limites: {
    limite_resgate_diario: number;
    limite_resgate_mensal: number;
    limite_transferencia_diaria: number;
    limite_pontos_campanha: number;
  };
  regras: {
    pontos_por_real_venda: number;
    multiplicador_bonificacao: number;
    prazo_aprovacao_saque: number;
    ativo_verificacao_kyc: boolean;
  };
  geral: {
    email_notificacoes: string;
    moeda_padrao: string;
    ativo_moderacao_automatica: boolean;
  };
  ultima_alteracao: string;
  alterado_por: string;
}

// Configurações por campanha — quando herdaPlataforma = false, usa os valores específicos
// quando herdaPlataforma = true, os valores de referência mostram o que a plataforma define
export const configuracoesCampanhas: ConfigCampanha[] = [
  {
    campanhaId: 'CAMP-001',
    campanhaNome: 'Vendas Q1 2026',
    empresaId: 'EMP-001',
    empresaNome: 'getPoints',
    herdaPlataforma: false,
    taxas: {
      taxa_processamento_pix: 1.8,
      taxa_compra_pontos: 4.5,
      taxa_transferencia_interna: 0.5,
    },
    limites: {
      limite_resgate_diario: 2000,
      limite_resgate_mensal: 8000,
      limite_transferencia_diaria: 5000,
      limite_pontos_campanha: 600000,
    },
    regras: {
      pontos_por_real_venda: 15,
      multiplicador_bonificacao: 2.0,
      prazo_aprovacao_saque: 24,
      ativo_verificacao_kyc: true,
    },
    geral: {
      email_notificacoes: 'campanha1@getpoints.com.br',
      moeda_padrao: 'BRL',
      ativo_moderacao_automatica: true,
    },
    ultima_alteracao: '2026-04-10T10:00:00Z',
    alterado_por: 'André Costa',
  },
  {
    campanhaId: 'CAMP-002',
    campanhaNome: 'Performance Abril',
    empresaId: 'EMP-001',
    empresaNome: 'getPoints',
    herdaPlataforma: true,
    taxas: {
      taxa_processamento_pix: 2.5,
      taxa_compra_pontos: 5.0,
      taxa_transferencia_interna: 1.0,
    },
    limites: {
      limite_resgate_diario: 1000,
      limite_resgate_mensal: 5000,
      limite_transferencia_diaria: 3000,
      limite_pontos_campanha: 500000,
    },
    regras: {
      pontos_por_real_venda: 10,
      multiplicador_bonificacao: 1.5,
      prazo_aprovacao_saque: 48,
      ativo_verificacao_kyc: true,
    },
    geral: {
      email_notificacoes: 'notificacoes@getpoints.com.br',
      moeda_padrao: 'BRL',
      ativo_moderacao_automatica: true,
    },
    ultima_alteracao: '2026-03-20T14:30:00Z',
    alterado_por: 'André Costa',
  },
  {
    campanhaId: 'CAMP-003',
    campanhaNome: 'Captação de Clientes',
    empresaId: 'EMP-002',
    empresaNome: 'Inova Digital',
    herdaPlataforma: false,
    taxas: {
      taxa_processamento_pix: 3.0,
      taxa_compra_pontos: 6.0,
      taxa_transferencia_interna: 1.5,
    },
    limites: {
      limite_resgate_diario: 1500,
      limite_resgate_mensal: 6000,
      limite_transferencia_diaria: 4000,
      limite_pontos_campanha: 400000,
    },
    regras: {
      pontos_por_real_venda: 20,
      multiplicador_bonificacao: 1.2,
      prazo_aprovacao_saque: 72,
      ativo_verificacao_kyc: false,
    },
    geral: {
      email_notificacoes: 'inova@getpoints.com.br',
      moeda_padrao: 'BRL',
      ativo_moderacao_automatica: false,
    },
    ultima_alteracao: '2026-03-01T09:00:00Z',
    alterado_por: 'Ricardo Ferreira',
  },
  {
    campanhaId: 'CAMP-004',
    campanhaNome: 'Capacitação Q2',
    empresaId: 'EMP-003',
    empresaNome: 'TechBrasil',
    herdaPlataforma: false,
    taxas: {
      taxa_processamento_pix: 1.5,
      taxa_compra_pontos: 3.0,
      taxa_transferencia_interna: 0.0,
    },
    limites: {
      limite_resgate_diario: 500,
      limite_resgate_mensal: 2000,
      limite_transferencia_diaria: 1500,
      limite_pontos_campanha: 200000,
    },
    regras: {
      pontos_por_real_venda: 5,
      multiplicador_bonificacao: 1.0,
      prazo_aprovacao_saque: 24,
      ativo_verificacao_kyc: true,
    },
    geral: {
      email_notificacoes: 'techbrasil@getpoints.com.br',
      moeda_padrao: 'BRL',
      ativo_moderacao_automatica: true,
    },
    ultima_alteracao: '2026-04-05T11:20:00Z',
    alterado_por: 'Fernanda Costa',
  },
  {
    campanhaId: 'CAMP-005',
    campanhaNome: 'Engajamento Trimestral',
    empresaId: 'EMP-002',
    empresaNome: 'Inova Digital',
    herdaPlataforma: true,
    taxas: {
      taxa_processamento_pix: 2.5,
      taxa_compra_pontos: 5.0,
      taxa_transferencia_interna: 1.0,
    },
    limites: {
      limite_resgate_diario: 1000,
      limite_resgate_mensal: 5000,
      limite_transferencia_diaria: 3000,
      limite_pontos_campanha: 500000,
    },
    regras: {
      pontos_por_real_venda: 10,
      multiplicador_bonificacao: 1.5,
      prazo_aprovacao_saque: 48,
      ativo_verificacao_kyc: true,
    },
    geral: {
      email_notificacoes: 'notificacoes@getpoints.com.br',
      moeda_padrao: 'BRL',
      ativo_moderacao_automatica: true,
    },
    ultima_alteracao: '2026-04-20T16:45:00Z',
    alterado_por: 'Ricardo Ferreira',
  },
  {
    campanhaId: 'CAMP-006',
    campanhaNome: 'Vendas Produto Novo',
    empresaId: 'EMP-004',
    empresaNome: 'SysInt',
    herdaPlataforma: true,
    taxas: {
      taxa_processamento_pix: 2.5,
      taxa_compra_pontos: 5.0,
      taxa_transferencia_interna: 1.0,
    },
    limites: {
      limite_resgate_diario: 1000,
      limite_resgate_mensal: 5000,
      limite_transferencia_diaria: 3000,
      limite_pontos_campanha: 500000,
    },
    regras: {
      pontos_por_real_venda: 10,
      multiplicador_bonificacao: 1.5,
      prazo_aprovacao_saque: 48,
      ativo_verificacao_kyc: true,
    },
    geral: {
      email_notificacoes: 'notificacoes@getpoints.com.br',
      moeda_padrao: 'BRL',
      ativo_moderacao_automatica: true,
    },
    ultima_alteracao: '2026-05-01T08:00:00Z',
    alterado_por: 'Paulo Henrique',
  },
];

// Valores padrão da plataforma para comparar
export const valoresPadraoPlataforma = {
  taxas: {
    taxa_processamento_pix: 2.5,
    taxa_compra_pontos: 5.0,
    taxa_transferencia_interna: 1.0,
  },
  limites: {
    limite_resgate_diario: 1000,
    limite_resgate_mensal: 5000,
    limite_transferencia_diaria: 3000,
    limite_pontos_campanha: 500000,
  },
  regras: {
    pontos_por_real_venda: 10,
    multiplicador_bonificacao: 1.5,
    prazo_aprovacao_saque: 48,
    ativo_verificacao_kyc: true,
  },
  geral: {
    email_notificacoes: 'notificacoes@getpoints.com.br',
    moeda_padrao: 'BRL',
    ativo_moderacao_automatica: true,
  },
};

// Categorias de configuração para agrupamento
export type CategoriaConfig = 'taxas' | 'limites' | 'regras' | 'geral';

export interface CampoConfig {
  chave: string;
  label: string;
  descricao: string;
  tipo: 'porcentagem' | 'numero' | 'boolean' | 'texto';
  categoria: CategoriaConfig;
}

export const camposConfiguracao: CampoConfig[] = [
  // Taxas
  { chave: 'taxa_processamento_pix', label: 'Taxa PIX', descricao: 'Taxa percentual cobrada sobre cada resgate PIX', tipo: 'porcentagem', categoria: 'taxas' },
  { chave: 'taxa_compra_pontos', label: 'Taxa Compra Pontos', descricao: 'Taxa percentual cobrada sobre compra de pontos', tipo: 'porcentagem', categoria: 'taxas' },
  { chave: 'taxa_transferencia_interna', label: 'Taxa Transferência', descricao: 'Taxa percentual sobre transferência entre participantes', tipo: 'porcentagem', categoria: 'taxas' },
  // Limites
  { chave: 'limite_resgate_diario', label: 'Limite Resgate Diário', descricao: 'Valor máximo de resgate PIX por dia (R$)', tipo: 'numero', categoria: 'limites' },
  { chave: 'limite_resgate_mensal', label: 'Limite Resgate Mensal', descricao: 'Valor máximo de resgate PIX por mês (R$)', tipo: 'numero', categoria: 'limites' },
  { chave: 'limite_transferencia_diaria', label: 'Limite Transferência Diária', descricao: 'Valor máximo de transferência entre participantes por dia (R$)', tipo: 'numero', categoria: 'limites' },
  { chave: 'limite_pontos_campanha', label: 'Limite Pontos Campanha', descricao: 'Quantidade máxima de pontos por campanha', tipo: 'numero', categoria: 'limites' },
  // Regras
  { chave: 'pontos_por_real_venda', label: 'Pontos por Real', descricao: 'Pontos ganhos por real em venda (padrão)', tipo: 'numero', categoria: 'regras' },
  { chave: 'multiplicador_bonificacao', label: 'Multiplicador Bonificação', descricao: 'Multiplicador de pontos em bonificações', tipo: 'numero', categoria: 'regras' },
  { chave: 'prazo_aprovacao_saque', label: 'Prazo Aprovação Saque', descricao: 'Prazo máximo em horas para aprovação de saques', tipo: 'numero', categoria: 'regras' },
  { chave: 'ativo_verificacao_kyc', label: 'Verificação KYC', descricao: 'Ativar verificação de identidade para novos cadastros', tipo: 'boolean', categoria: 'regras' },
  // Geral
  { chave: 'email_notificacoes', label: 'Email Notificações', descricao: 'Email remetente para notificações do sistema', tipo: 'texto', categoria: 'geral' },
  { chave: 'moeda_padrao', label: 'Moeda Padrão', descricao: 'Moeda padrão da campanha', tipo: 'texto', categoria: 'geral' },
  { chave: 'ativo_moderacao_automatica', label: 'Moderação Automática', descricao: 'Ativar moderação automática de conteúdo', tipo: 'boolean', categoria: 'geral' },
];

// Helper para obter o valor efetivo (campanha ou plataforma)
export function getValorEfetivo(
  campanhaId: string,
  categoria: CategoriaConfig,
  chave: string
): { valor: number | string | boolean; herdaPlataforma: boolean } {
  const config = configuracoesCampanhas.find((c) => c.campanhaId === campanhaId);
  if (!config) {
    const padrao = valoresPadraoPlataforma[categoria][chave as keyof (typeof valoresPadraoPlataforma)[typeof categoria]];
    return { valor: padrao as number | string | boolean, herdaPlataforma: true };
  }
  if (config.herdaPlataforma) {
    const padrao = valoresPadraoPlataforma[categoria][chave as keyof (typeof valoresPadraoPlataforma)[typeof categoria]];
    return { valor: padrao as number | string | boolean, herdaPlataforma: true };
  }
  const valor = config[categoria][chave as keyof (typeof config)[typeof categoria]];
  return { valor: valor as number | string | boolean, herdaPlataforma: false };
}